"use client"
import Header from "../components/layout/Header";

 const FallBackUI = () => {
    return (
      <>
      <Header LogoData={[]}/>
      <h3>Something went wrong</h3>
        </>
    );
  }


  export default FallBackUI;